"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderSummaryMobile = void 0;
const React = require("react");
const react_1 = require("react");
const TSalesOrderType_1 = require("../../../types/TSalesOrderType");
const SalesOrderSummarySidePanel_1 = require("../SalesOrderSummarySidePanel");
const SalesOrderSummaryDriverDetails_1 = require("../SalesOrderSummaryDriverDetails");
const ShowSalesOrderSummarySidePanelButton_1 = require("../ShowSalesOrderSummarySidePanelButton");
const SalesOrderSummaryMap_1 = require("../SalesOrderSummaryMap");
const SalesOrderSummaryMobile = ({ salesOrder, visibleMap }) => {
    const { type } = salesOrder;
    const [open, setOpen] = (0, react_1.useState)(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(SalesOrderSummaryMap_1.SalesOrderSummaryMap, { salesOrder: salesOrder, variant: "mobile", isVisible: visibleMap === "mobile" }),
        type === TSalesOrderType_1.TSalesOrderType.Delivery && (React.createElement(SalesOrderSummaryDriverDetails_1.SalesOrderSummaryDriverDetails, { salesOrder: salesOrder, type: "mobile" },
            React.createElement(ShowSalesOrderSummarySidePanelButton_1.ShowSalesOrderSummarySidePanelButton, { salesOrder: salesOrder, setOpen: setOpen }))),
        type === TSalesOrderType_1.TSalesOrderType.Pickup && (React.createElement(ShowSalesOrderSummarySidePanelButton_1.ShowSalesOrderSummarySidePanelButton, { salesOrder: salesOrder, setOpen: setOpen })),
        React.createElement(SalesOrderSummarySidePanel_1.SalesOrderSummarySidePanel, { salesOrder: salesOrder, open: open, setOpen: setOpen })));
};
exports.SalesOrderSummaryMobile = SalesOrderSummaryMobile;
//# sourceMappingURL=index.js.map